//푸시 알림 종료
export enum NotificationType {
    PROJECT = 'Project',
    DOCUMENT = 'Document',
    BILLING = 'Billing',
    ACCOUNT = 'Account'
}

//푸시 데이터
export interface NotificationResponseData {
    notificationId: number; //식별자
    notificationType: NotificationType; //종류
    title: string; //제목
    isRead: boolean; //읽음 여부
}